import React from "react";
import {useParams} from "react-router-dom";
import {Flex} from "@chakra-ui/react";

import AuditLogTable from "../components/Tables/components/AuditLog";


export function TransactionAuditLog() {
    const { id } = useParams();

    const columns = React.useMemo(
        () => [
            {
                header: 'Дата и время',
                accessorKey: 'inserted_at',
            },
            {
                header: 'Событие',
                accessorKey: 'name',
            },
            {
                header: 'Запрос',
                accessorKey: 'meta.request/url',
            },
            {
                header: 'Время ответа',
                accessorKey: 'data/sanitized.latency_us',
            },
            {
                header: 'Запрос/Ответ',
                accessorKey: 'show',
            }
        ],
        []
    )

    return (

        <Flex direction='column' pt={{ base: "120px", md: "75px" }}>
            <AuditLogTable
                title={"Audit logs"}
                columns = {columns}
                id={id}
            />
        </Flex>
    );
}
